export default "__VITE_ASSET__7bb30cc6__"